import V2 from '@/V2/V2';
import NotFoundPage from '@/V2/NotFoundPage';
import AuthContainer from '@/V2/auth/AuthContainer';
import Login from '@/V2/auth/Login';
import JoinOrganisation from '@/V2/auth/JoinOrganisation';
import PasswordReset from '@/V2/auth/PasswordReset';
import PasswordResetRequest from '@/V2/auth/PasswordResetRequest';
import AwaitTwoFa from '@/V2/auth/AwaitTwoFa';
import EnableTwoFa from '@/V2/auth/EnableTwoFa';
import SamlLogin from '@/V2/auth/SamlLogin';
import AnalyticsPage from '@/V2/pages/AnalyticsPage';
import DocumentsPage from '@/V2/pages/DocumentsPage';
import CollectSessionsList from '@/V2/collect/CollectSessionsList';
import Customer from '@/V2/customers/Customer';
import Customers from '@/V2/customers/Customers';
import NewCustomer from '@/V2/customers/New';
import CustomerDetails from '@/V2/customers/CustomerDetails';
import DatabasesTable from '@/V2/documents/DatabasesTable';
import DocumentFontsDisplay from '@/V2/documents/DocumentFontsDisplay';
import DocumentResultsPanel from '@/V2/documents/document-view/DocumentResultsPanel';
import Highlighter from '@/V2/documents/Highlighter';
import ParsedDetailsHighlighter from '@/V2/documents/ParsedDetailsHighlighter';
import MetadataDisplay from '@/V2/documents/MetadataDisplay';
import TextPages from '@/V2/documents/TextPages';
import ApiSettings from '@/V2/settings/API/API';
import CreateApiKey from '@/V2/settings/API/CreateKey';
import APIKeys from '@/V2/settings/API/APIKeys';
import EditApiKey from '@/V2/settings/API/EditKey';
import ViewApiKey from '@/V2/settings/API/ViewKey';
import EditIdentityProvider from '@/V2/settings/SAML/Edit';
import NewIdentityProvider from '@/V2/settings/SAML/New';
import AccountSettings from '@/V2/settings/Account';
import SamlSettings from '@/V2/settings/SAML/Saml';
import Settings from '@/V2/settings/Settings';
import TeamSettings from '@/V2/settings/TeamSettings';
import NotificationsSettings from '@/V2/settings/Notifications';
import CollectConfigSettings from '@/V2/settings/collect/CollectConfig';
import WebhooksSettings from '@/V2/settings/webhooks/Webhooks';
import CreateWebhook from '@/V2/settings/webhooks/CreateWebhook';
import ListWebhooks from '@/V2/settings/webhooks/ListWebhooks';
import Credit from '@/V2/credit/Credit.vue';
import CreditTransactionsPage from '@/V2/credit/CreditTransactionsPage';
import GranularInsights from '@/V2/credit/granular-insights/GranularInsights.vue';
import CustomerOverview from '@/V2/customers/CustomerOverview.vue';
import DecisionEngine from '@/V2/decision-engine/DecisionEngine';
import Blocklist from '@/V2/decision-engine/blocklist/Blocklist';
import BlocklistEdit from '@/V2/decision-engine/blocklist/BlocklistEdit';
import Detectors from '@/V2/decision-engine/Detectors';
import Checks from '@/V2/decision-engine/checks/Checks';
import CheckEdit from '@/V2/decision-engine/checks/CheckEdit';
import FraudRules from '@/V2/decision-engine/FraudRules';
import RuleEdit from '@/V2/decision-engine/rules/RuleEdit.vue';
import PreviousDocumentsTable from '@/V2/documents/PreviousDocumentsTable.vue';

export default [
  {
    path: '/auth',
    component: AuthContainer,
    children: [
      {
        path: '/',
        redirect: '/auth/login',
      },
      {
        path: 'join/:invitationCode',
        component: JoinOrganisation,
        name: 'join',
        props: true,
      },
      {
        path: 'login',
        component: Login,
        name: 'login',
      },
      {
        path: 'login/saml',
        component: SamlLogin,
        name: 'login-saml',
      },
      {
        path: 'password',
        component: PasswordResetRequest,
        name: 'password-reset-request',
      },
      {
        path: 'password/:passwordResetHash',
        component: PasswordReset,
        name: 'password-reset',
        props: true,
      },
      {
        path: '2fa/await',
        component: AwaitTwoFa,
        name: 'await-2fa',
      },
      {
        path: '2fa/enable',
        component: EnableTwoFa,
        name: 'enable-2fa',
      },
    ],
  },
  {
    path: '/',
    component: V2,
    children: [
      {
        path: '/',
        redirect: '/customers',
      },
      {
        path: 'analytics',
        component: AnalyticsPage,
      },
      {
        path: 'documents',
        component: DocumentsPage,
        name: 'documents-search',
      },
      {
        path: 'decision-engine',
        component: DecisionEngine,
        children: [
          {
            path: '',
            redirect: '/decision-engine/checks',
            name: 'decision-engine-index',
          },
          {
            path: 'checks',
            component: Checks,
            name: 'decision-engine-checks',
          },
          {
            path: 'checks-edit',
            component: CheckEdit,
            name: 'decision-engine-checks-edit',
            props: true,
          },
          {
            path: 'rules',
            component: FraudRules,
            name: 'decision-engine-rules',
            props: true,
          },
          {
            path: 'rules-edit',
            component: RuleEdit,
            name: 'decision-engine-rule-edit',
            props: true,
          },
          {
            path: 'detectors',
            component: Detectors,
            name: 'decision-engine-detectors',
          },
          {
            path: 'blocklist',
            component: Blocklist,
            name: 'decision-engine-blocklist',
          },
          {
            path: 'blocklist-edit',
            component: BlocklistEdit,
            name: 'decision-engine-blocklist-edit',
            props: true,
          },
        ],
      },
      {
        path: 'settings',
        component: Settings,
        children: [
          {
            path: '',
            redirect: '/settings/account',
            name: 'settings-view',
          },
          {
            path: 'account',
            component: AccountSettings,
            name: 'account-settings-view',
          },
          {
            path: 'team',
            component: TeamSettings,
            name: 'team-settings-view',
          },
          {
            path: 'api',
            component: ApiSettings,
            children: [
              {
                path: '',
                component: APIKeys,
                name: 'api-settings-list-keys',
              },
              {
                path: 'create',
                component: CreateApiKey,
                name: 'api-settings-create-key',
              },
              {
                path: ':api_key/edit',
                component: EditApiKey,
                name: 'api-settings-edit-key',
              },
              {
                path: ':api_key/view',
                component: ViewApiKey,
                name: 'api-settings-view-key',
              },
              {
                path: '*',
                redirect: '/settings/api',
              },
            ],
          },
          {
            path: 'webhooks',
            component: WebhooksSettings,
            children: [
              {
                path: '/',
                component: ListWebhooks,
                name: 'webhooks-settings-list',
              },
              {
                path: 'create',
                component: CreateWebhook,
                name: 'webhooks-settings-create',
              },
              {
                path: ':webhookId/edit',
                component: CreateWebhook,
                name: 'webhooks-settings-edit',
                props: true,
              },
              {
                path: '*',
                redirect: '/',
              },
            ],
          },
          {
            path: 'notifications',
            component: NotificationsSettings,
            name: 'notifications-settings-view',
          },
          {
            path: 'saml',
            component: SamlSettings,
            name: 'saml-settings-view',
            children: [
              {
                path: 'new',
                component: NewIdentityProvider,
                name: 'saml-settings-new-identity-provider',
              },
              {
                path: ':identity_provider_id/edit',
                name: 'saml-settings-edit-identity-provider-view',
                component: EditIdentityProvider,
              },
            ],
          },
          {
            path: 'collect',
            component: CollectConfigSettings,
            name: 'collect-config-settings-view',
            children: [
              {
                path: 'email',
                component: () =>
                  import(
                    /* webpackChunkName: "collectEmailConfig" */ '@/V2/settings/collect/CollectEmailCustomization'
                  ),
                name: 'collect-config-email-customization',
              },
              {
                path: 'portal',
                component: () =>
                  import(
                    /* webpackChunkName: "collectPortalConfig" */ '@/V2/settings/collect/CollectPortalCustomization'
                  ),
                name: 'collect-config-portal-customization',
              },
            ],
          },
          // legacy routes redirects
          {
            path: 'rules',
            redirect: '/decision-engine/rules',
          },
        ],
      },
      {
        path: 'customer',
        name: 'customer-wrapper',
        component: Customer,
        children: [
          {
            path: ':customer_id',
            component: CustomerDetails,
            children: [
              {
                path: 'credit-transactions',
                name: 'customer-credit-transactions',
                component: CreditTransactionsPage,
              },
              {
                path: 'credit',
                name: 'customer-credit',
                component: Credit,
              },
              {
                path: 'credit/:type',
                component: GranularInsights,
                name: 'customer-credit-granular-insight',
              },
              {
                path: '/',
                name: 'customer-overview',
                component: CustomerOverview,
                children: [
                  {
                    path: 'document/:document_id',
                    component: DocumentResultsPanel,
                    children: [
                      {
                        path: '/',
                        redirect:
                          '/customer/:customer_id/document/:document_id/signals',
                      },
                      {
                        path: 'signals',
                        name: 'document-signals',
                        component: () => import('@/V2/documents/Signals'),
                      },
                      {
                        path: 'text',
                        name: 'document-text',
                        component: TextPages,
                      },
                      {
                        path: 'metadata',
                        name: 'document-metadata',
                        component: MetadataDisplay,
                      },
                      {
                        path: 'fonts-metadata',
                        name: 'document-fonts',
                        component: DocumentFontsDisplay,
                      },
                      {
                        path: 'compare',
                        name: 'document-compare',
                        component: () => import('@/V2/documents/Compare'),
                      },
                      {
                        path: 'highlight',
                        name: 'document-highlighter',
                        component: Highlighter,
                      },
                      {
                        path: 'parsed-details-highlighter',
                        name: 'document-parsed-details-highlighter',
                        component: ParsedDetailsHighlighter,
                      },
                      {
                        path: 'seen-before',
                        name: 'document-seen-before',
                        component: PreviousDocumentsTable,
                        props: true,
                      },
                      {
                        path: 'copycat-text',
                        name: 'document-copycat-text',
                        component: PreviousDocumentsTable,
                        props: true,
                      },
                      {
                        path: 'databases',
                        name: 'document-databases',
                        component: DatabasesTable,
                      },
                      {
                        path: 'recovered',
                        name: 'document-recovered',
                        component: () => import('@/V2/documents/XRay'),
                      },
                      {
                        path: 'template',
                        name: 'matching-template',
                        component: () =>
                          import('@/V2/documents/TemplateCompare'),
                      },
                      {
                        path: 'api',
                        name: 'document-api',
                        component: () =>
                          import('@/V2/documents/document-api/DocumentApi'),
                      },
                    ],
                  },
                ],
              },
              {
                path: '*',
                component: CustomerOverview,
              },
            ],
          },
        ],
      },
      {
        path: 'customers',
        component: Customers,
        name: 'customers-view',
        children: [
          {
            path: 'new',
            component: NewCustomer,
            name: 'new-customer',
          },
          {
            path: ':customer_id',
            component: Customer,
            children: [
              {
                path: '/',
                component: CustomerDetails,
                name: 'customer-details',
              },
              {
                path: '*',
                component: CustomerDetails,
              },
            ],
          },
        ],
      },
      {
        name: 'collect-view',
        path: 'collect',
        component: CollectSessionsList,
      },
    ],
  },
  {
    path: '*',
    name: '404',
    component: NotFoundPage,
  },
];
